var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPearl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "cb-map-layer",
    viewBox: "0 0 708 708",
    width: 708,
    height: 708,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    d: "M396.31 33V91.67L412.2 107.57H539.01V180.63H573.08V159.05H674L674 213.18H670.75V283.59H698V302.52L670.75 329.77V465.67H624.56V470.5H632.5V509.2H521.6V465.67H515.92V540.24H481.48L414.85 563.33H344.82V639.8C344.82 648.88 332.71 675 305.08 675C277.44 675 263.44 650.02 263.44 634.5V625.79L138.14 625.79L48.81 536.46V467.18H81.74V464.53H60.16V410.02H108.99V377.47H98.02V393.37H47.29L9.82001 355.89V323.34L48.81 266.56H100.67V277.16H116.95V266.56H155.18L155.18 183.28L214.61 123.85L263.44 123.85V33H396.31ZM176.38 569.01L161.62 554.25L168.43 547.43L151.77 530.78L98.02 530.78V541.76H116.19L149.5 575.07V589.45L158.59 603.84L176.38 603.84V569.01ZM515.93 411.53H521.6V360.05L442.49 360.05V378.98H393.66L393.66 453.55L323.63 473.99L308.49 523.58V539.1H283.88V544.78H302.81V582.25H308.49V541.75H313.79V525.47H361.1V490.27H422.43V503.52H447.03V438.79H487.54V395.26H515.93V411.53ZM487.54 518.65V465.66H482.24V518.65H487.54ZM543.18 465.66V487.23H605.64V465.66H543.18ZM470.12 140.12H445.52V275.63H397L386.09 265.03H383.06V318.79H358.83L348.61 328.63L359.59 332.41H431.89V311.21L475.42 311.21L499.27 327.11H552.27V368H541.67V381.62H605.64V340.74H600.34V305.54H605.64V213.17H470.12V140.12ZM395.93 122.33L381.92 108.33L366.4 123.47V172.68H259.66L253.22 161.7H245.65V177.98H309.62V210.53V215.83H348.23L378.14 245.74H401.99V201.07H388.36V129.9L395.93 122.33ZM645.01 310.85V284.35H631.38V310.85H645.01ZM377.38 378.6H334.23V313.87H312.27V348.7H242.62V381.63H230.89V392.61H301.3V441.06H304.33V430.46H323.63L368.3 408.51H377.38V378.6ZM279.72 453.93L279.72 414.18H243L243 486.1H224.45L197.2 472.85H157.83V503.89H163.89L180.92 520.93L173.73 528.12L180.92 535.31L188.11 528.12L203.63 543.64V571.65H208.56L214.23 569H263.44V582.25H269.12V525.47H292.21V519.41L289.56 509.19V473.61L279.72 453.93ZM146.86 439.55H195.69V359.67L182.06 349V312.36H258.15L273.67 319.93H279.72V293.05H258.15V232.11H279.72V210.53H229.76V161.7H221.43L216.13 171.92V304.03H156.32H133.23L79.1 317.66V328.63L163.13 358.54V377.47H144.5V412.5H146.5L146.86 439.55ZM497 193.5C501.6 193.5 505.33 189.77 505.33 185.17C505.33 180.57 501.6 176.84 497 176.84C492.4 176.84 488.67 180.57 488.67 185.17C488.67 189.77 492.4 193.5 497 193.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "objects"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer_2",
    d: "M187.4 601.6C187.4 603.257 186.057 604.6 184.4 604.6H179.8C178.143 604.6 176.8 603.257 176.8 601.6V600.8C176.8 599.143 178.143 597.8 179.8 597.8H184.4C186.057 597.8 187.4 599.143 187.4 600.8V601.6Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_3",
    d: "M206.3 437.3C206.3 438.957 204.957 440.3 203.3 440.3H198.7C197.043 440.3 195.7 438.957 195.7 437.3V431.9C195.7 430.243 197.043 428.9 198.7 428.9H203.3C204.957 428.9 206.3 430.243 206.3 431.9V437.3Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_4",
    d: "M222.9 333.6C222.9 335.257 221.557 336.6 219.9 336.6H215.3C213.643 336.6 212.3 335.257 212.3 333.6V328.2C212.3 326.543 213.643 325.2 215.3 325.2H219.9C221.557 325.2 222.9 326.543 222.9 328.2V333.6Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_5",
    d: "M313 346C313 347.657 311.657 349 310 349H306C304.343 349 303 347.657 303 346V317C303 315.343 304.343 314 306 314H310C311.657 314 313 315.343 313 317V346Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_6",
    d: "M361.5 376C361.5 377.657 360.157 379 358.5 379H353.1C351.443 379 350.1 377.657 350.1 376V370.6C350.1 368.943 351.443 367.6 353.1 367.6H358.5C360.157 367.6 361.5 368.943 361.5 370.6V376Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_7",
    d: "M447.8 511.5C447.8 513.157 446.457 514.5 444.8 514.5H437.9C436.243 514.5 434.9 513.157 434.9 511.5V506.1C434.9 504.443 436.243 503.1 437.9 503.1H444.8C446.457 503.1 447.8 504.443 447.8 506.1V511.5Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_8",
    d: "M556 429C556 430.657 554.657 432 553 432H545.4C543.743 432 542.4 430.657 542.4 429V421.4C542.4 419.743 543.743 418.4 545.4 418.4H553C554.657 418.4 556 419.743 556 421.4V429Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_9",
    d: "M595.4 462.3C595.4 463.957 594.057 465.3 592.4 465.3H586.3C584.643 465.3 583.3 463.957 583.3 462.3V456.9C583.3 455.243 584.643 453.9 586.3 453.9H592.4C594.057 453.9 595.4 455.243 595.4 456.9V462.3Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_10",
    d: "M579.5 388.9C579.5 390.557 578.157 391.9 576.5 391.9H571.9C570.243 391.9 568.9 390.557 568.9 388.9V384.3C568.9 382.643 570.243 381.3 571.9 381.3H576.5C578.157 381.3 579.5 382.643 579.5 384.3V388.9Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_11",
    d: "M671.1 419.1C671.1 420.757 669.757 422.1 668.1 422.1H651.4C649.743 422.1 648.4 420.757 648.4 419.1V413.8C648.4 412.143 649.743 410.8 651.4 410.8H668.1C669.757 410.8 671.1 412.143 671.1 413.8V419.1Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_12",
    d: "M676.4 291.9C676.4 293.557 675.057 294.9 673.4 294.9V294.9C671.743 294.9 670.4 293.557 670.4 291.9V286.6C670.4 284.943 671.743 283.6 673.4 283.6V283.6C675.057 283.6 676.4 284.943 676.4 286.6V291.9Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_13",
    d: "M655.2 194.3C655.2 195.957 653.857 197.3 652.2 197.3H624.2C622.543 197.3 621.2 195.957 621.2 194.3V188.9C621.2 187.243 622.543 185.9 624.2 185.9H652.2C653.857 185.9 655.2 187.243 655.2 188.9V194.3Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_14",
    d: "M654.8 185.9V175.3M621.5 185.9V175.3",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_15",
    d: "M521.1 356.6C521.1 358.257 519.757 359.6 518.1 359.6H512C510.343 359.6 509 358.257 509 356.6V352C509 350.343 510.343 349 512 349H518.1C519.757 349 521.1 350.343 521.1 352V356.6Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_16",
    d: "M413 208.7C413 210.357 411.657 211.7 410 211.7H404.6C402.943 211.7 401.6 210.357 401.6 208.7V204.1C401.6 202.443 402.943 201.1 404.6 201.1H410C411.657 201.1 413 202.443 413 204.1V208.7Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_17",
    d: "M396.3 80.35C396.3 81.8136 395.114 83 393.65 83V83C392.187 83 391 81.8136 391 80.35V71.25C391 69.7864 392.187 68.6 393.65 68.6V68.6C395.114 68.6 396.3 69.7864 396.3 71.25V80.35Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_18",
    d: "M268.4 78.0502C268.4 79.5138 267.214 80.7002 265.75 80.7002V80.7002C264.287 80.7002 263.1 79.5138 263.1 78.0502V68.9502C263.1 67.4866 264.287 66.3002 265.75 66.3002V66.3002C267.214 66.3002 268.4 67.4866 268.4 68.9502V78.0502Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_19",
    d: "M396.3 42.1001C396.3 43.757 394.957 45.1001 393.3 45.1001L354.6 45.1001C352.943 45.1001 351.6 43.757 351.6 42.1001V35.2001C351.6 33.5433 352.943 32.2001 354.6 32.2001L393.3 32.2001C394.957 32.2001 396.3 33.5433 396.3 35.2001V42.1001Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_20",
    d: "M319.8 42.1001C319.8 43.757 318.457 45.1001 316.8 45.1001L266.8 45.1001C265.143 45.1001 263.8 43.757 263.8 42.1001V35.2001C263.8 33.5433 265.143 32.2001 266.8 32.2001L316.8 32.2001C318.457 32.2001 319.8 33.5433 319.8 35.2001V42.1001Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_21",
    d: "M504.6 210.2C504.6 211.857 503.257 213.2 501.6 213.2H500.8C499.143 213.2 497.8 211.857 497.8 210.2V192.7C497.8 191.043 499.143 189.7 500.8 189.7H501.6C503.257 189.7 504.6 191.043 504.6 192.7V210.2Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_22",
    d: "M413.3 140.1V198.5C413.3 200.157 411.957 201.5 410.3 201.5H403",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_23",
    d: "M542.4 431.6H521.2M542.4 418.7H521.2",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_24",
    d: "M302.4 557.7C302.4 559.357 301.057 560.7 299.4 560.7H286.5C284.843 560.7 283.5 559.357 283.5 557.7V547C283.5 545.343 284.843 544 286.5 544H299.4C301.057 544 302.4 545.343 302.4 547V557.7Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_25",
    d: "M434.9 506.15C434.9 507.393 433.893 508.4 432.65 508.4V508.4C431.408 508.4 430.4 507.393 430.4 506.15V505.35C430.4 504.108 431.408 503.1 432.65 503.1V503.1C433.893 503.1 434.9 504.108 434.9 505.35V506.15Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_26",
    d: "M328.9 310.1C328.9 311.757 327.557 313.1 325.9 313.1H319.8C318.143 313.1 316.8 311.757 316.8 310.1V279C316.8 277.343 318.143 276 319.8 276H325.9C327.557 276 328.9 277.343 328.9 279V310.1Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_27",
    d: "M334.2 320.3L347.1 314.6",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_28",
    d: "M264.2 392.2L268.244 398.671C268.542 399.147 268.7 399.698 268.7 400.261V414.2",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_29",
    d: "M166.2 221.5C166.2 223.157 164.857 224.5 163.2 224.5H157.8C156.143 224.5 154.8 223.157 154.8 221.5V215.4C154.8 213.743 156.143 212.4 157.8 212.4H163.2C164.857 212.4 166.2 213.743 166.2 215.4V221.5Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_30",
    d: "M55.1694 317.592C56.5673 318.48 56.9809 320.333 56.0934 321.732L45.3967 338.585C44.5132 339.977 42.6719 340.395 41.2738 339.521L36.7566 336.698C35.3468 335.817 34.9224 333.957 35.8105 332.551L46.4936 315.643C47.3802 314.24 49.2378 313.823 50.6387 314.713L55.1694 317.592Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_31",
    d: "M135.9 491.1C135.9 492.757 134.557 494.1 132.9 494.1H106.3C104.643 494.1 103.3 492.757 103.3 491.1V482.7C103.3 481.043 104.643 479.7 106.3 479.7H122.3C123.957 479.7 125.3 478.357 125.3 476.7V472.8C125.3 471.143 126.643 469.8 128.3 469.8H132.9C134.557 469.8 135.9 471.143 135.9 472.8V491.1Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_32",
    d: "M82.1001 513.7C80.4432 513.7 79.1001 512.357 79.1001 510.7V468.3C79.1001 467.472 79.7717 466.8 80.6001 466.8V466.8C81.4285 466.8 82.1001 467.472 82.1001 468.3V502.4C82.1001 503.45 82.9508 504.3 84.0001 504.3V504.3C85.0495 504.3 85.9001 505.151 85.9001 506.2V510.7C85.9001 512.357 84.557 513.7 82.9001 513.7H82.1001Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_33",
    d: "M182.8 594.8C182.8 596.457 181.457 597.8 179.8 597.8V597.8C178.143 597.8 176.8 596.457 176.8 594.8V594.7C176.8 593.043 178.143 591.7 179.8 591.7V591.7C181.457 591.7 182.8 593.043 182.8 594.7V594.8Z",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_34",
    d: "M243 598.2H176.8",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_35",
    d: "M73.8001 514.1H85.9001",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_36",
    d: "M198.7 289.3V237",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_37",
    d: "M216.1 216.2H199.8C198.143 216.2 196.8 214.857 196.8 213.2V183.7",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_38",
    d: "M442.9 359.7H399.7",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_39",
    d: "M413.3 354H472.8C474.457 354 475.8 355.343 475.8 357V359.7",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_40",
    d: "M516.3 465.7V440.85C516.3 439.497 517.397 438.4 518.75 438.4V438.4C520.103 438.4 521.2 437.303 521.2 435.95V411.5",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_41",
    d: "M487.2 465.7V438.8",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_42",
    d: "M504.2 212.8V146.9M498.1 212.8V192.4",
    className: "line"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "areas"
  }, /*#__PURE__*/React.createElement("path", {
    id: "transparent-area",
    d: "M146 526.734V442.266C146 440.738 144.762 439.5 143.234 439.5H60.7656C59.2382 439.5 58 440.738 58 442.266V462.234C58 463.762 59.2382 465 60.7656 465H78.7344C80.2618 465 81.5 466.238 81.5 467.766V512.854C81.5 513.588 81.7914 514.291 82.31 514.81L96.19 528.69C96.7086 529.209 97.4121 529.5 98.1456 529.5H143.234C144.762 529.5 146 528.262 146 526.734Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "transparent-area_2",
    d: "M604.5 384.766V461.648C604.5 463.176 603.262 464.414 601.734 464.414H545.027C543.5 464.414 542.262 463.176 542.262 461.648V384.766C542.262 383.238 543.5 382 545.027 382H601.734C603.262 382 604.5 383.238 604.5 384.766Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "areaLabels"
  }, /*#__PURE__*/React.createElement("text", {
    id: "attacker",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 297,
    y: 99.712
  }, "Attackers")), /*#__PURE__*/React.createElement("text", {
    id: "defender",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 268,
    y: 642.712
  }, "Defenders")), /*#__PURE__*/React.createElement("text", {
    id: "A",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 100,
    y: 468.712
  }, "A")), /*#__PURE__*/React.createElement("text", {
    id: "B",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 574,
    y: 426.712
  }, "B")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "text"
  }, /*#__PURE__*/React.createElement("text", {
    id: "B Ramp",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 653,
    y: 375.968
  }, "B Ramp")), /*#__PURE__*/React.createElement("text", {
    id: "A Link",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 204,
    y: 445.968
  }, "A Link")), /*#__PURE__*/React.createElement("text", {
    id: "A Main",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 85,
    y: 506.968
  }, "A Main")), /*#__PURE__*/React.createElement("text", {
    id: "B Tower",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 478,
    y: 420.968
  }, "B Tower")), /*#__PURE__*/React.createElement("text", {
    id: "A Main_2",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 85,
    y: 506.968
  }, "A Main")), /*#__PURE__*/React.createElement("text", {
    id: "A Dugout",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34,
    y: 489.968
  }, "A Dugout")), /*#__PURE__*/React.createElement("text", {
    id: "Mid Shops",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 394,
    y: 188.968
  }, "Mid Shops")), /*#__PURE__*/React.createElement("text", {
    id: "B Ramp_2",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 619,
    y: 220.968
  }, "B Ramp")), /*#__PURE__*/React.createElement("text", {
    id: "Mid Top",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 265,
    y: 190.968
  }, "Mid Top")), /*#__PURE__*/React.createElement("text", {
    id: "A Restaurant",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 150,
    y: 224.968
  }, "A Restaurant")), /*#__PURE__*/React.createElement("text", {
    id: "A Main_3",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 51,
    y: 351.968
  }, "A Main")), /*#__PURE__*/React.createElement("text", {
    id: "Mid Place",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 298,
    y: 254.968
  }, "Mid Place")), /*#__PURE__*/React.createElement("text", {
    id: "A Art",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 204,
    y: 341.968
  }, "A Art")), /*#__PURE__*/React.createElement("text", {
    id: "Mid Doors",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 323,
    y: 322.968
  }, "Mid Doors")), /*#__PURE__*/React.createElement("text", {
    id: "B Link",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 451,
    y: 334.968
  }, "B Link")), /*#__PURE__*/React.createElement("text", {
    id: "B Main",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 622,
    y: 318.968
  }, "B Main")), /*#__PURE__*/React.createElement("text", {
    id: "B Screen",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 637,
    y: 438.968
  }, "B Screen")), /*#__PURE__*/React.createElement("text", {
    id: "B Hall",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 559,
    y: 495.968
  }, "B Hall")), /*#__PURE__*/React.createElement("text", {
    id: "B Tunnel",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 441,
    y: 450.968
  }, "B Tunnel")), /*#__PURE__*/React.createElement("text", {
    id: "Defender Side Records",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 327,
    y: 540.968
  }, "Defender Side Records")), /*#__PURE__*/React.createElement("text", {
    id: "Water",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 287,
    y: 493.968
  }, "Water")), /*#__PURE__*/React.createElement("text", {
    id: "Mid Connector",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 308,
    y: 443.968
  }, "Mid Connector")), /*#__PURE__*/React.createElement("text", {
    id: "A Flowers",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 160,
    y: 547.968
  }, "A Flowers")), /*#__PURE__*/React.createElement("text", {
    id: "A Secret",
    xmlSpace: "preserve",
    fontSize: 8.5,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 90,
    y: 567.968
  }, "A Secret")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPearl);
export default __webpack_public_path__ + "static/media/pearl.71e8a864.svg";
export { ForwardRef as ReactComponent };